<template>
  <div class="houseList">
    <NavComponent :index="1"></NavComponent>
    <div
      class="banner"
      v-bind:style="{ backgroundImage: 'url(https://cdn.hanlandglobal.com/rent_banner.jpg)' }"
    >
      <div class="search">
        <el-input placeholder="请输入内容" v-model="data.keyword" class="input-with-select">
          <el-select v-model="data.city" slot="prepend" placeholder="请选择">
            <el-option
              v-for="item in info.city"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="data.type" slot="prepend" placeholder="请选择">
            <el-option
              v-for="item in info.type"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <el-button slot="append" icon="el-icon-search" @click="Search()"></el-button>
        </el-input>
      </div>
    </div>
    <SideBarComponent></SideBarComponent>
    <Loading v-if="LOADING"></Loading>
    <div v-else class="main">
      <div class="title">
        <div class="title-bg">{{ title }}</div>
      </div>
      <div v-if="aparmentList.length != 0" class="content-container">
        <!-- <div v-if="data.house_type == 1" class="aparment-list">
          <div
            v-for="(item, index) in aparmentList"
            :key="index"
            class="aparment-item"
            v-bind:style="{
              backgroundImage: 'url(' + item.image + ')',
            }"
            @click="goDetail(item.id)"
          >
            <h3>{{ item.title }}</h3>
            <p>{{ item.city }}</p>
          </div>
        </div> -->
        <div class="house-list">
          <div
            class="house-item"
            v-for="(item, index) in aparmentList"
            :key="index"
            @click="goDetail(item.id)"
          >
            <div class="house-image" v-bind:style="{
              backgroundImage: 'url(' + item.image + ')',
            }"></div>
            <div class="bottom-list">
              <h3>{{ item.title }}</h3>
              <div class="city">
                <img class="marker" :src="marker" />{{ item.city }}
              </div>
            </div>
          </div>
        </div>
        <el-pagination
          class="pagination"
          background
          layout="prev, pager, next"
          prev-text="上一页"
          next-text="下一页"
          :total="houseInfo.total"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
      <div v-else class="content-container none-list">
          暂未搜索到任何房源
      </div>
    </div>
    <FooterComponent></FooterComponent>
  </div>
</template>
<script>
import FooterComponent from "@components/FooterComponent";
import NavComponent from "@components/NavComponent";
import SideBarComponent from "@components/SideBarComponent";
import about_2 from "@assets/image/management/about-2.jpg";
import marker from "@assets/image/icon/local.png";

export default {
  name: "MoveHousePage",
  computed: {},
  components: {
    FooterComponent,
    NavComponent,
    SideBarComponent,
  },
  data() {
    return {
      about_2,
      marker,
      title: "高端新楼盘",
      info:{},
      LOADING:false,
      data:{
        house_type:1,
        limit:6,
        page:1,
        city:null,
        keyword:''
      },
      houseInfo: { total: 2 },
      aparmentList: [],
    };
  },
  mounted() {
    if (this.$route.path.split("/").slice(-1)[0] == "1") {
      this.data.house_type = 1;
      this.title = "高端新楼盘";
    } else {
      this.data.house_type = 2;
      this.title = "精品二手房";
    }
    this.getBuilding()
    this.getSetting()
  },
  beforeDestroy(){
    console.log('lllll')
  },
  methods: {
    goDetail(id) {
      window.open("/houseHosting/"+id, "_blank");
    },
    getBuilding(){
      var that = this
      this.LOADING = true
      this.axios.get(this.url+'/api/web/loupan',{params:this.data}).then(function(response){
        that.LOADING = false;
        that.aparmentList = response.data.data.data;
      }).catch(function() {
      });
    },
    getSetting(){
      var that = this
      this.axios.get(this.url+'/api/web/loupan/setting',{}).then(function(response){
        that.info= response.data.data;
        console.log(that.info)
      }).catch(function() {
      });
    },
    Search(){
      this.getBuilding()
    },
    handleCurrentChange(val){
      console.log(val)
    }
  },
};
</script>
<style lang="scss" scoped>
.houseList {
  min-height: 100vh;
}
.none-list{
  min-height: 40vh;
  color: $font;
  text-align: center;
}
.banner {
  width: 100%;
  height: 24.3rem;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}
.search{
  width: 40rem;
  position: absolute;
  bottom: 2rem;
  left: 50%;
  right: 50%;
  margin-left: -20rem;
}
.title {
  font-size: 1.4rem;
  text-align: center;
  color: white;
  font-weight: bold;
  background: url("~@/assets/image/houseList/section_title_bg_1.png") repeat
    scroll center center transparent;
  margin-bottom: 5rem;
  margin-top: 3rem;
  line-height: 2.6rem;
}
.title-bg {
  font-size: 1.4rem;
  text-align: center;
  color: white;
  font-weight: bold;
  background: url("~@/assets/image/houseList/section_title_bg_w.png") no-repeat
    scroll center center transparent;
  margin-bottom: 4rem;
  line-height: 2.6rem;
}
.aparment-list {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 2rem;
  cursor: pointer;
}
.aparment-list::after{
  content: '';
  width: 17.2rem;
  height: auto;
}
.aparment-item {
  width: 17.2rem;
  height: 16.5rem;
  text-align: center;
  color: #fff;
  border-radius: 0.4rem;
  margin-bottom: 1.5rem;
  background-repeat: no-repeat;
  background-position: center;
  background-size:cover;
  h3 {
    margin-top: 12rem;
  }
}
.aparment-list::after {
  width: 17.2rem;
  content: "";
}
.house-list {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  color: #0e2d57;
  cursor: pointer;
  padding-bottom: 2rem;
  img {
    width: 19.2rem;
    height: 12.4rem;
    background-color: #a5a2a2;
    border-radius: 0.5rem 0.5rem 0px 0px;
  }
  .house-item {
    background: #fff;
    margin-bottom: 2rem;
    border-radius: 0.5rem;
    .bottom-list {
      box-sizing: border-box;
      border-left: 1px solid #999;
      border-right: 1px solid #999;
      border-bottom: 1px solid #999;
    }
    h3 {
      padding: 1rem 0 0 1.6rem;
      font-size: 1.2rem;
    }
    .city {
      margin-left: 1.6rem;
      .marker {
        width: 1rem;
        height: 1.3rem;
        background: #fff;
        margin: 0.7rem 1rem 1rem 0;
      }
    }
  }
  .house-image{
    width: 19.2rem;
    height: 12.4rem;
    background-position: center;
    background-size: 19.2rem 12.4rem;
    background-repeat: no-repeat;
  }
}
.house-list::after{
  content: '';
  width: 19.2rem;
  height: auto;
}
.pagination{
  display: flex;
  align-items: center;
  justify-content: center;
}
@media only screen and (max-width: 1024px){
  .banner{
    height: 18rem;
  }
  .search{
    display:none;
  }
  .title{
    padding: 0 2%;
  }
  .house-list{
    width: 90%;
    margin: 0 auto;
    display: block;
    .house-image{
      width: 100%;
      height: 18.4rem;
      background-position: center;
      background-size: 100% 18.4rem;
      background-repeat: no-repeat;
    }
  }
}
</style>
<style lang="scss">
.houseList{ 
  .el-pagination {
    text-align: center;
    margin: 2rem auto;
  }
  .el-input-group__prepend{
    width: 14rem;
  }
  .el-input-group__prepend .el-select .el-input__inner{
      width: 6rem;
      margin-left: 1rem;
  }
  // .el-input-group__prepend .el-select .el-input{
  //   margin-right: 1rem;
  // }
  .el-input-group__prepend .el-select{
    width: 8rem;

  }
}
@media only screen and (max-width: 1024px){
  .houseList{
    .el-pagination span{
        width: 6rem;
    }
    .el-pagination .btn-prev{
      width: 6rem;
    }
    .el-pagination .btn-next{
      width: 6rem;
    }
    .el-pagination .el-pager{
      margin: 0 1rem;
    }
  }
}

</style>